import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import { useGameStore } from '@/stores/game'

interface ModalState {
  showBetslip: boolean
  showFavorites: boolean
  showCheckout: boolean
}

export const useModalStore = defineStore('modal', {
  state: (): ModalState => ({
    showBetslip: false,
    showFavorites: false,
    showCheckout: false
  }),

  actions: {
    openBetslip() {
      useAuthStore().refreshAuthFromExternalSources()
      const gameStore = useGameStore()
      if (
        gameStore.getBetSettings?.client_surface_ui?.online?.use_platform_betslip ===
        false
      ) {
        return
      }
      this.showBetslip = true
    },
    closeBetslip() {
      this.showBetslip = false
    },
    openFavorites() {
      this.showFavorites = true
    },
    closeFavorites() {
      this.showFavorites = false
    },
    openCheckout() {
      this.showCheckout = true
    },
    closeCheckout() {
      this.showCheckout = false
    }
  }
}) 